'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getEndpoint = require('../get-endpoint');

var _getEndpoint2 = _interopRequireDefault(_getEndpoint);

var _config = require('../config');

var _dataProvider = require('../data-provider');

var _dataProvider2 = _interopRequireDefault(_dataProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the user's eligibility for Rewards
 * @param {GetRewardsStateParamsType} params The function parameters
 * @param {TunnelType} params.tunnel The request tunnel
 * @returns {Promise<boolean>} Boolean rewards eligibility
 */
exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(params) {
        var tunnel, endpoint, proxyAgent, data;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        tunnel = params.tunnel;
                        endpoint = (0, _getEndpoint2.default)('rewards', '/account/eligible');
                        proxyAgent = (0, _config.getProxy)('rewards');
                        _context.next = 5;
                        return (0, _dataProvider2.default)(endpoint, tunnel, {
                            agent: proxyAgent
                        });

                    case 5:
                        data = _context.sent;

                        if (!data.eligible) {
                            _context.next = 8;
                            break;
                        }

                        return _context.abrupt('return', data.eligible);

                    case 8:
                        return _context.abrupt('return', false);

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function getRewardState(_x) {
        return _ref.apply(this, arguments);
    }

    return getRewardState;
}();
//# sourceMappingURL=rewards.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/rewards/rewards.js
// module id = 460
// module chunks = 0